module.exports = __webpack_public_path__ + "img/dsjfxzx.6b3047b4.png";